/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable no-unused-vars, no-useless-return, curly, nonblock-statement-body-position */
/* eslint-disable no-confusing-arrow */
import React, { useState, useEffect } from 'react';
import { SUB_SCREENS, ALLOC_TYPES } from '../../constants';
import { CloseIcon, TableActions, F } from '../CommonUI';
import { apiClient } from '../../../../config/axios.config';
import { BASE_EMPLOYEE_URL } from '../../../../store/apiConfig';
import EmployeeMasterDeleteConfirm from './EmployeeMasterDeleteConfirm';

const EMPTY_CA_FORM = { costCentre: '', pctAlloc: '', remarks: '' };

/**
 * Cost Allocation Sub-Screen
 * ┌──────────────────────────────────────────────────────────────┐
 * │  GET    /api/cost-allocation/:empCode      → [{ id, ... }]  │
 * │  POST   /api/cost-allocation/:empCode      → { id, ... }    │
 * │  PUT    /api/cost-allocation/:empCode/:id  → { success }    │
 * │  DELETE /api/cost-allocation/:empCode/:id  → { success }    │
 * └──────────────────────────────────────────────────────────────┘
 */
function CostAllocationScreen({ empName, empCode, onClose, opts, readOnly }) {
  const allowedAllocTypes = ALLOC_TYPES;
  const currentEntityCode = localStorage.getItem('entityCode') || '';
  const [productOptions, setProductOptions] = useState([]);
  const [productOptionsLoading, setProductOptionsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ ...EMPTY_CA_FORM });
  const [allocType, setAllocType] = useState(allowedAllocTypes[0] || '');
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (!empCode) return;
    setLoading(true);
    apiClient
      .create(`${BASE_EMPLOYEE_URL}/get-allocation`, {
        employeeId: empCode,
        costTyp: allocType,
      })
      .then(res => {
        const data = res?.result || res || [];
        const rs = Array.isArray(data) ? data : [];
        setRows(
          rs.map(r => ({
            id: r.id || r.CostCd || Math.random().toString(),
            costCentre: r.CostCd || r.costCentre || '',
            pctAlloc: r.AllocationPerc || r.pctAlloc || '',
            remarks: r.Remarks || r.remarks || '',
          })),
        );
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load cost allocation.');
        setLoading(false);
      });
  }, [empCode, allocType]);

  useEffect(() => {
    if (readOnly) {
      setShowForm(false);
      setEditing(null);
    }
  }, [readOnly]);

  /** HR codelist: @Typ = 'COSTCODE' → CostCodes from HRMS (employee id sent for SP context) */
  useEffect(() => {
    if (!empCode || allocType !== 'Product') {
      setProductOptions([]);
      return;
    }
    setProductOptionsLoading(true);
    apiClient
      .create(`${BASE_EMPLOYEE_URL}/get-hrcodelist`, {
        codeType: 'COSTCODE',
        param1: '',
        param2: '',
        param3: '',
        param4: currentEntityCode,
        employeeId: empCode,
      })
      .then(data => {
        const resultList = data?.result || [];
        const list = Array.isArray(resultList)
          ? resultList.map(item => {
              const code = String(
                item.CostCode ||
                  item.costCode ||
                  item.Code ||
                  item.CODE ||
                  item.RowKey ||
                  '',
              ).trim();
              return {
                value: code,
                label:
                  String(
                    item.Description || item.NAME || item.RowValue || code,
                  ).trim() || code,
              };
            })
          : [];
        setProductOptions(list);
        setProductOptionsLoading(false);
      })
      .catch(() => {
        setProductOptions([]);
        setProductOptionsLoading(false);
      });
  }, [empCode, allocType]);

  useEffect(() => {
    setForm({ ...EMPTY_CA_FORM });
    setShowForm(false);
    setEditing(null);
  }, [allocType]);

  const cf = (n, v) => setForm(p => ({ ...p, [n]: v }));
  const getOptionLabel = (options, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    if (value == null || value === '') return '';
    if (!Array.isArray(options) || options.length === 0) return String(value);
    const matched = options.find(opt => {
      if (typeof opt === 'object' && opt !== null) {
        return String(opt.value).trim() === String(value);
      }
      return String(opt).trim() === String(value);
    });
    if (!matched) return String(value);
    if (typeof matched === 'object' && matched !== null) {
      return String(matched.label || matched.value || value);
    }
    return String(matched);
  };
  const allocationCodeLabel =
    allocType === 'Product' ? 'Product' : 'Cost Centre';
  const allocationCodeOptions =
    allocType === 'Product' ? productOptions : opts?.costCentre || [];
  const totalPct = rows.reduce((s, r) => s + (parseFloat(r.pctAlloc) || 0), 0);
  const resetForm = () => {
    setForm({ ...EMPTY_CA_FORM });
    setShowForm(false);
    setEditing(null);
  };

  const doSave = () => {
    const mandatory = ['costCentre', 'pctAlloc'];
    const missing = mandatory.find(f => !form[f]);
    if (missing) {
      const el = document.getElementById(`f-${missing}`);
      if (el) el.focus();
      return;
    }

    const newTotal =
      totalPct +
      (parseFloat(form.pctAlloc) || 0) -
      (editing !== null ? parseFloat(rows[editing]?.pctAlloc) || 0 : 0);
    if (newTotal > 100) {
      setError('Total allocation cannot exceed 100%');
      return;
    }

    const normalizedCostCentre = String(form.costCentre || '').trim();
    const existingIndex = rows.findIndex(
      (r, idx) =>
        idx !== editing &&
        String(r.costCentre || '').trim() === normalizedCostCentre,
    );

    const req = apiClient.create(`${BASE_EMPLOYEE_URL}/create-allocation`, {
      empCd: empCode,
      employeeId: empCode,
      costTyp: allocType,
      costCd: form.costCentre,
      allocPerc: parseFloat(form.pctAlloc),
      remarks: form.remarks || '',
    });

    if (req) {
      setError(null);
      req
        .then(data => {
          if (editing !== null || existingIndex !== -1) {
            const targetIndex = editing !== null ? editing : existingIndex;
            setRows(p =>
              p.map((d, i) =>
                i === targetIndex
                  ? { ...form, id: d.id || p[targetIndex]?.id }
                  : d,
              ),
            );
          } else {
            setRows(p => [...p, { ...form, id: data?.result?.id || data?.id }]);
          }
          resetForm();
        })
        .catch(() => {
          setError('Failed to save.');
        });
    } else {
      if (editing !== null)
        setRows(p => p.map((d, i) => (i === editing ? { ...form } : d)));
      else setRows(p => [...p, { ...form }]);
      resetForm();
    }
  };
  const doEdit = i => {
    setForm({ ...rows[i] });
    setEditing(i);
    setShowForm(true);
  };
  const openDeleteConfirm = i => {
    setDeleteIndex(i);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    if (deleteLoading) return;
    setDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  const performDelete = () => {
    if (deleteIndex == null) return;
    const i = deleteIndex;
    const payload = {
      employeeId: empCode,
      costTyp: allocType,
      costCd: rows[i]?.costCentre,
    };

    setDeleteLoading(true);
    apiClient
      .delete(`${BASE_EMPLOYEE_URL}/delete-allocation`, { data: payload })
      .then(() => {
        setRows(p => p.filter((_, j) => j !== i));
        setDeleteLoading(false);
        setDeleteModalOpen(false);
        setDeleteIndex(null);
      })
      .catch(() => {
        setError('Failed to delete.');
        setDeleteLoading(false);
      });
  };

  return (
    <div className="ov">
      <div
        className="sub-modal sub-modal-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="sub-modal-top comp-modal-top">
          <div className="sub-modal-title">
            <div className="sub-modal-title-row sub-modal-title-row--stacked comp-modal-title-row">
              <span className="sub-modal-icon sub-modal-icon--lg comp-modal-icon-shell">
                <span className="comp-modal-icon-inner">
                  {SUB_SCREENS[1].icon}
                </span>
              </span>
              <div className="sub-modal-title-block">
                <h2>Cost Allocation</h2>
                {empCode && (
                  <span className="sub-modal-emp sub-modal-emp--stacked">
                    {[empName, empCode].filter(Boolean).join(' \u00b7 ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="mdl-x" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="sub-modal-body">
          {error && (
            <div
              style={{
                padding: '12px 20px',
                background: 'var(--red-l)',
                color: 'var(--red)',
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 12,
                borderRadius: 'var(--r)',
              }}
            >
              {error}
            </div>
          )}
          {loading ? (
            <div className="sub-empty">
              <span>Loading cost allocation...</span>
            </div>
          ) : (
            <>
              {showForm && !readOnly && (
                <div className="ca-form-bar">
                  <F
                    label={allocationCodeLabel}
                    name="costCentre"
                    value={form.costCentre}
                    onChange={cf}
                    options={allocationCodeOptions}
                    disabled={
                      editing !== null ||
                      (allocType === 'Product' && productOptionsLoading)
                    }
                    required
                  />
                  <F
                    label="% Allocation"
                    name="pctAlloc"
                    type="number"
                    value={form.pctAlloc}
                    onChange={cf}
                    placeholder="0"
                    min="0"
                    max="100"
                    required
                  />
                  <F
                    label="Remarks"
                    name="remarks"
                    value={form.remarks}
                    onChange={cf}
                  />
                  <div className="ca-form-btns">
                    <button
                      className="btn em-btn em-btn-p em-btn-sm"
                      onClick={doSave}
                    >
                      {editing !== null ? 'Update' : 'Save'}
                    </button>
                    <button
                      className="btn em-btn em-btn-sm"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
              {rows.length > 0 ? (
                <div
                  className="dep-table-wrap"
                  style={{ marginTop: showForm && !readOnly ? 16 : 0 }}
                >
                  <table className="dep-table dep-table--cost-allocation">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{allocationCodeLabel}</th>
                        <th style={{ textAlign: 'left' }}>% Allocation</th>
                        <th>Remarks</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td style={{ fontWeight: 600 }}>
                            {allocType === 'Product'
                              ? getOptionLabel(productOptions, r.costCentre)
                              : r.costCentre}
                          </td>
                          <td style={{ textAlign: 'left', fontWeight: 600 }}>
                            {r.pctAlloc}%
                          </td>
                          <td>{r.remarks || '—'}</td>
                          <td>
                            <TableActions
                              readOnly={readOnly}
                              onEdit={() => doEdit(i)}
                              onDelete={() => openDeleteConfirm(i)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="ca-total-row">
                        <td />
                        <td style={{ fontWeight: 700 }}>Total</td>
                        <td
                          style={{
                            textAlign: 'left',
                            fontWeight: 700,
                            color:
                              totalPct === 100
                                ? 'var(--grn)'
                                : totalPct > 100
                                  ? 'var(--red)'
                                  : 'var(--txt)',
                          }}
                        >
                          {totalPct}%
                        </td>
                        <td colSpan={2}>
                          {totalPct !== 100 && (
                            <span className="ca-warn">
                              {totalPct < 100
                                ? `${100 - totalPct}% remaining`
                                : 'Exceeds 100%'}
                            </span>
                          )}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              ) : (
                !showForm && (
                  <div className="sub-empty">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9m-9 9a9 9 0 019-9"
                        stroke="#cbd5e1"
                        strokeWidth="1.5"
                      />
                    </svg>
                    <span>No cost allocations found.</span>
                  </div>
                )
              )}
              {!showForm && !readOnly && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 16,
                  }}
                >
                  <button
                    className="btn em-btn em-btn-p"
                    onClick={() => setShowForm(true)}
                    disabled={
                      totalPct >= 100 ||
                      (allocType === 'Product' && productOptionsLoading)
                    }
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14m-7-7h14"
                        stroke="#fff"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    Add Allocation
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        <div className="ca-footer">
          <div className="ca-footer-label">Allocation Type</div>
          <div className="sw ca-footer-select">
            <select
              className="form-select external-filter-input  form-select"
              value={allocType}
              onChange={e => {
                const nextType = e.target.value;
                if (allowedAllocTypes.includes(nextType)) {
                  setAllocType(nextType);
                }
              }}
            >
              <option value="" disabled>
                Select Allocation Type
              </option>
              {ALLOC_TYPES.map(o => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>
            <svg
              className="chev"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              style={{ display: 'none' }}
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="#94a3b8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <EmployeeMasterDeleteConfirm
        isOpen={deleteModalOpen}
        toggle={closeDeleteModal}
        onConfirm={performDelete}
        loading={deleteLoading}
        message={
          deleteIndex != null && rows[deleteIndex] ? (
            <>
              Are you sure you want to delete this allocation (
              <span className="em-delete-confirm__highlight">
                {allocType === 'Product'
                  ? getOptionLabel(productOptions, rows[deleteIndex].costCentre)
                  : rows[deleteIndex].costCentre}{' '}
                · {rows[deleteIndex].pctAlloc}%
              </span>
              )?
            </>
          ) : null
        }
      />
    </div>
  );
}

export default CostAllocationScreen;
